<template>
    <div class="inputs-additional-info">
        <CoreTwoColumnsRow class="mb-3">
            <template #left>
                <CoreBorderWrapper
                    class="flex-grow-1 flex-shrink-1 flex-basis-55"
                    :condensed="true"
                >
                    {{ $t('§ui.placeholder_select_country_required') }}
                    {{ isFieldRequired('country_id') }}
                </CoreBorderWrapper>
            </template>
            <template #right>
                <CoreDropdown
                    class="flex-grow-1 flex-shrink-1 flex-basis-45"
                    name="country"
                    :placeholder="$t(placeholderFor('country_id', '§ui.placeholder_select_country_required'))"
                    :condensed="true"
                    :disabled="clientStore.saving || isPlaceholder"
                    :options="optionsStore.countryFinancingAvailableOptions"
                    :validator="v$.country_id"
                    v-model="clientStore.clientData.country_id"
                />
            </template>
        </CoreTwoColumnsRow>

        <CoreStringInput
            class="flex-grow-1 flex-shrink-1 flex-basis-45 mb-3"
            :placeholder="placeholderFor('street', '§ui.placeholder_eq_operator_street')"
            name="street"
            :condensed="true"
            :disabled="clientStore.saving || isPlaceholder"
            :value="clientStore.clientData.street"
            :validator="v$.street"
            v-model="clientStore.clientData.street"
        />

        <div class="flex-grow-1 flex-shrink-1 flex-basis-45 flex mb-3">
            <CoreStringInput
                class="flex-basis-40 inputs-additional-info__postal-code-input"
                :placeholder="placeholderFor('postal_code', '§ui.placeholder_eq_operator_postal')"
                name="postal_code"
                :condensed="true"
                :disabled="clientStore.saving || isPlaceholder"
                :validator="v$.postal_code"
                v-model="clientStore.clientData.postal_code"
            />
            <CoreStringInput
                class="flex-basis-60"
                :placeholder="placeholderFor('city', '§ui.placeholder_eq_operator_city')"
                name="city"
                :condensed="true"
                :disabled="clientStore.saving || isPlaceholder"
                :validator="v$.city"
                v-model="clientStore.clientData.city"
            />
        </div>
    </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import rules from '../validationRules.js'
import { useClientStore } from '@/stores/client'
import { useOptionsStore } from '@/stores/options'
import CoreBorderWrapper from '@/components/core/CoreBorderWrapper.vue'
import CoreTwoColumnsRow from '@/components/core/CoreTwoColumnsRow.vue'
import CoreStringInput from '@/components/core/CoreStringInput.vue'
import CoreDropdown from '@/components/core/CoreDropdown.vue'

const IS_MODAL = true

export default {
    name: 'InputsAdditionalInfo',

    props: {
        showDnbSearch: {
            type: Boolean,
            default: true,
        },
    },

    components: {
        CoreBorderWrapper,
        CoreTwoColumnsRow,
        CoreStringInput,
        CoreDropdown,
    },

    data() {
        return { v$: {}, clientStore: useClientStore(), optionsStore: useOptionsStore() }
    },

    computed: {
        isPlaceholder() {
            return !!this.clientStore.clientData.is_dummy
        },

        isValid() {
            return !this.v$.$invalid
        },
    },

    watch: {
        isValid: {
            handler(newValue) {
                this.clientStore.isValidAdditionalInfo = newValue
            },
            immediate: true,
        },
    },

    created() {
        this.optionsStore = useOptionsStore()
    },

    mounted() {
        this.$nextTick(() => {
            this.v$ = useVuelidate(rules(IS_MODAL), this.clientStore.clientData)
        })
    },

    methods: {
        placeholderFor(fieldName, defaultKey) {
            if (!this.showDnbSearch) return defaultKey
            return this.clientStore.dnbMissingFields.includes(fieldName)
                ? '§ui.placeholder_dnb_not_obtained'
                : defaultKey
        },
    },
}
</script>

<style scoped>
.inputs-additional-info__postal-code-input {
    width: 6.4rem;
    margin-right: 16px;
}
</style>
